var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 45C34.9264 45 45 34.9264 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45ZM9.64335 22.5005C9.64335 15.4111 15.3841 9.64335 22.4401 9.64335C29.5629 9.64335 35.3576 15.4111 35.3576 22.5005C35.3576 29.5899 29.5899 35.3576 22.5005 35.3576C15.4111 35.3576 9.64335 29.5899 9.64335 22.5005ZM21.2148 26.3576V28.9291H23.7862V26.3576H21.2148ZM21.2148 23.7862H23.7862V16.0719H21.2148V23.7862Z",
    fill: "#FA5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon_warning.4c668934512d8e013b51e96b4a66770b.svg";
export { ForwardRef as ReactComponent };